import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    addCustomField: translate({ id: 'orders.customFields.add' }),
    maxCustomFieldsReached: (maxCustomFieldCount: number) =>
      translate({
        id: 'orders.edit.validation.customFields.maxLimit',
        values: { maxCustomFieldCount },
      }),
    emptyCustomFieldName: translate({ id: 'orders.edit.validation.customFields.emptyFieldName' }),
  }))

  return api
}
